// src/services/userService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  ORDER_MANAGEMENT_LIST,
  SINGLE_ORDER_MANAGEMENT_LIST,
  ORDER_DETAILS,
  ORDER_EXPORT,
  ORDER_STAFF_LIST,
  ORDER_UPDATE,
  GET_ORDER_DETAILED_INFO,
  GET_NEW_ORDER_LIST,
  ORDER_STATUS,
  GROUPED_ORDER_STATUS_CHANGE,
  GET_GROUPED_ORDER_INFO,
  CANCEL_ORDER,
  ORDER_SINGLE_EXPORT,
  DISH_ORDER_EXPORT
} from "../../config/constants"; // Adjust endpoints as per your config

const orderSingleService = createApi({
  reducerPath: "orderSingleService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Order"],
  endpoints: (builder) => ({
    getOrder: builder.query({
      query: (bodyData) => ({
        url: SINGLE_ORDER_MANAGEMENT_LIST, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),
    getGroupedOrderInfo: builder.query({
      query: (bodyData) => ({
        url: GET_GROUPED_ORDER_INFO, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),
   

    getOrderNew: builder.query({
      query: (bodyData) => ({
        url: GET_NEW_ORDER_LIST, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),
   
    getOrderDetails: builder.query({
      query: (data) => ({
        url: `${GET_ORDER_DETAILED_INFO}`, // Endpoint to fetch user details
        method: "POST",
        data: data,
      }),
      providesTags: ["OrderDetail"],
    }),

    getStaffOrder: builder.query({
      query: (bodyData) => ({
        url: ORDER_STAFF_LIST, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Order"],
    }),

    updateOrder: builder.mutation({
      query: ({ userId, updatedData }) => ({
        url: `${ORDER_UPDATE}/${userId}`, // Endpoint to update a user
        method: "PUT",
        data: updatedData, // Updated user data
      }),
      invalidatesTags: ["Order"],
    }),

    getOrderExportFile: builder.mutation({
      query: (csvData) => ({
        url: ORDER_SINGLE_EXPORT, // Endpoint to fetch ingredient list
        method: "POST",
         data: csvData,
      }),
    }),
    getDishOrderExportFile: builder.mutation({
      query: (csvData) => ({
        url: DISH_ORDER_EXPORT, // Endpoint to fetch ingredient list
        method: "POST",
         data: csvData,
      }),
    }),
    changeMealStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: ORDER_STATUS + id, // Endpoint to fetch ingredient list
        method: "PUT",
        data: data, // Pass the body data for the request
      }),
      invalidatesTags: ["Order"],
    }),
    changeGroupedOrderStatus: builder.mutation({
      query: ({ data, id }) => ({
        url: GROUPED_ORDER_STATUS_CHANGE + id, // Endpoint to fetch ingredient list
        method: "PUT",
        data: data, // Pass the body data for the request
      }),
      invalidatesTags: ["Order"],
    }),
    cancelOrder: builder.mutation({
      query: (data) => ({
        url: CANCEL_ORDER, // Endpoint to fetch ingredient list
        method: "POST",
        data: data,
      }),
      invalidatesTags: ["Order"],
    }),
  }),
});

export const {
  useGetOrderQuery,
  useGetOrderNewQuery,
  useGetStaffOrderQuery,
  useGetOrderDetailsQuery,
  useGetOrderExportFileMutation,
  useGetDishOrderExportFileMutation,
  useUpdateOrderMutation,
  useGetGroupedOrderInfoQuery,
  

  useChangeMealStatusMutation,
  useChangeGroupedOrderStatusMutation,
  useCancelOrderMutation,
} = orderSingleService;

// Export the reducer to be included in the store
export default orderSingleService;
